import { signInWithEmailAndPassword } from 'firebase/auth'

import { auth } from '../firebase'

export async function signInWithEmail(email: string, pass: string) {
    const res = await signInWithEmailAndPassword(auth, email, pass)
    return res
}
